import React from 'react';
import { Ripple } from 'primereact/ripple';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Actions from '../../../../../../reducer/actions';

const About = () => {
	const navigate = useNavigate();

	const dispatch = useDispatch();

	const language = useSelector((state) => state.language);

	const currentPage = useSelector((state) => state.currentPage);
	const setCurrentPage = (payload) => dispatch({ type: Actions.SetCurrentPage, payload });

	const setAboutPage = (payload) => dispatch({ type: Actions.SetAboutPage, payload });

	return (
		<div
			className="menu-option"
			role="button"
			tabIndex="0"
			onClick={() => {
				setCurrentPage('About');
				navigate('/About');
			}}
		>
			<div
				className="p-ripple"
				id="about"
			>
				<p style={currentPage === 'About' ? { color: '#FDC82FFF' } : {}}>{language.MenuBarOptionsAbout}</p>
				<Ripple />
			</div>
			<div className="sub-menu" id="mode">
				<div
					className="p-ripple"
					role="button"
					tabIndex="0"
					onClick={() => {
						setCurrentPage('About');
						setAboutPage('about');
						navigate('/About');
						document.activeElement.blur();
					}}
				>
					<p>{language.MenuBarAboutSubMenuPlatform}</p>
					<Ripple />
				</div>
				<div className="divider" />
				<div
					className="p-ripple"
					role="button"
					tabIndex="0"
					onClick={() => {
						setCurrentPage('About');
						setAboutPage('how');
						navigate('/About');
						document.activeElement.blur();
					}}
				>
					<p>{language.MenuBarAboutSubMenuHow}</p>
					<Ripple />
				</div>
				<div className="divider" />
				<div
					className="p-ripple"
					role="button"
					tabIndex="0"
					onClick={() => {
						setCurrentPage('About');
						setAboutPage('methodology');
						navigate('/About');
						document.activeElement.blur();
					}}
				>
					<p>{language.MenuBarAboutSubMenuMethodology}</p>
					<Ripple />
				</div>
			</div>
		</div>
	);
};

export default About;
